/**
 * RPS-BAR-TEXT
 * Style du nombre affiché dans chaque barre des graphiques « Par populations » du RPS (Karasek et Gollac),
 * partagé pour que les deux affichages gardent la même police.
 */
export const RPS_BAR_TEXT = {
  textposition: "inside",
  insidetextanchor: "end",
  textfont: { color: "#ffffff", family: "Open Sans, sans-serif", size: 14, weight: 700 }
} as const
